export default {"src":"/_next/static/media/mediawind.41f2951d.svg","height":24,"width":181,"blurWidth":0,"blurHeight":0};